import type { Address } from "viem";

export const ATOMIC_QUEUE_CONTRACT_ADDRESS =
  "0x228c44bb4885c6633f4b6c83f14622f37d5112e5" as Address;

export const DEFAULT_WITHDRAW_SLIPPAGE = 20; // 20 bps (0.2%)
export const DEFAULT_DEPOSIT_SLIPPAGE = 50; // 50 bps (0.5%)

export const DEFAULT_DEADLINE = 3; // 3 days

export const NATIVE_TOKEN_FOR_BRIDGE_FEE =
  "0xeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeee" as Address;

export const CHAINLINK_ADDRESS =
  "0x5f4eC3Df9cbd43714FE2740f5E3616155c5b8419" as Address; // usd per eth

export const DEFAULT_APPROVAL_AMOUNT = BigInt(2) ** BigInt(256) - BigInt(1);

export const NUCLEUS_BASE_URL = "https://backend.nucleusearn.io/v1/protocol";
